import {isNullOrUndefined} from "../../../services/Validator";

export default function GlossaryResearchClearButton({search, onClear}) {
    // Used in GlossaryResearch to display button clearing current
    // research

    // BUILD
    if (!search || isNullOrUndefined(onClear))
        return null
    return (
        <button className="flex justify-center items-center text-greyLight9 hover:text-secondaryLight3 transition"
                onClick={onClear}
                aria-label="Effacer la recherche">
            <i className="material-icons text-[20px]">close</i>
        </button>
    );
}